<template>
    <modal name="add-product-modal" @before-open="beforeOpen" :resizable="true" transition="pop-out"
           :width="800"
           :height="575">
        <h4 class="text-center panel-heading">Product toevoegen</h4>
        <form @submit.prevent="addProduct()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-6 mb-20">
                        <label>Artikelnummer*</label>
                        <input type="text"
                               class="form-control"
                               required
                               v-model="product.articleNumber">
                    </div>
                    <div class="col-sm-6 mb-20">
                        <label>Prijs*</label>
                        <div class="input-group">
                            <span class="input-group-addon" id="basic-addon1">€</span>
                            <input type="number" min="0" step="0.01" required v-model="product.price" class="form-control">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-6 mb-20">
                        <label>Nederlandse naam*</label>
                        <input type="text"
                               class="form-control"
                               v-model="product.dutchTitle"
                               required>
                    </div>
                    <div class="col-sm-6 mb-20">
                        <label>Franse naam</label>
                        <input type="text"
                               v-model="product.frenchTitle"
                               class="form-control">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-6 mb-20">
                        <label>Nederlandse omschrijving</label>
                        <textarea class="form-control"
                                  rows="8"
                                  v-model="product.dutchDescription"></textarea>
                    </div>
                    <div class="col-sm-6 mb-20">
                        <label>Franse omschrijving</label>
                        <textarea class="form-control"
                                  rows="8"
                                  v-model="product.frenchDescription"></textarea>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-6 mb-20">
                        <label>Categorie code*</label>
                        <input type="text" class="form-control" v-model="product.categoryCode" required>
                    </div>
                    <div class="col-sm-6 mb-20">
                        <label>Afbeelding (200 x 200)</label>
                        <input type="file"
                               @change="upload($event.target.files)" accept="image/*">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-4">
                        <button type="submit" class="btn btn-danger">Opslaan</button>
                    </div>
                </div>
            </div>
        </form>
    </modal>
</template>
<script>
    import { mapGetters } from 'vuex'
    import * as types from '../../store/mutation-types'

    export default {
        name: 'AddProduct',
        data() {
            return {
                product: {
                    categoryId: null,
                    active: true,
                    articleNumber: '',
                    price: 0.00,
                    dutchTitle: '',
                    frenchTitle: '',
                    dutchDescription: '',
                    frenchDescription: '',
                    categoryCode: '',
                    imageLocation: ''
                },
                file: null
            }
        },
        methods: {
            addProduct() {
                this.$store.commit(types.SET_PRODUCT_TO_CREATE, this.product)
                this.$store.dispatch('createProduct').then(() => {
                    if (this.isProductCreated) {
                        this.product.categoryId = null
                        this.product.articleNumber = ''
                        this.product.price = 0
                        this.product.dutchTitle = ''
                        this.product.frenchTitle = ''
                        this.product.dutchDescription = ''
                        this.product.frenchDescription = ''
                        this.product.categoryCode = ''
                        this.product.imageLocation = ''

                        this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Product is aangemaakt!' })
                        this.$modal.hide('add-product-modal')
                    }
                })
            },
            beforeOpen(event) {
                if (event.params.category) {
                    this.product.categoryId = event.params.category
                }
            },
            upload(image) {
                let data = new FormData()
                if (image !== '') {
                    this.file = image.item(0)
                    data.append('images', this.file, this.file.name)

                    this.$store.dispatch('uploadImage', data).then(() => {
                        if (this.imageLocation) {
                            this.product.imageLocation = this.imageLocation
                        }
                    })
                }
            }
        },
        computed: {
            ...mapGetters({
                isProductCreated: 'isProductCreated',
                imageLocation: 'imageLocation'
            })
        }
    }
</script>

<style scoped>
    .mb-20 {
        margin-bottom: 20px;
    }
</style>
